import { RouteComponentProps, useNavigate } from '@reach/router';
import FormHeader from 'components/formHeader/FormHeader';
import Page from 'components/shared/Page';
import { ChooseFreeTrialPackageForm } from 'components/chooseFreeTrialPackageForm/ChooseFreeTrialPackage';
import { AppPath } from 'appConstants';
import { AddFreeTrialParser } from './models';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { clearPackageForm } from 'reducers/misc';

const SubscribeFreeTrial: React.FC<RouteComponentProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      //clear choose free trial package form
      dispatch(clearPackageForm());
    };
  }, []);

  return (
    <Page isPublic={false} className={'SubscribePage'}>
      <div className="PageContent WidthContent HeightContent SubscribePage">
        <div className="SubscriptionPageHead">
          <FormHeader
            activeStep={1}
            numOfSteps={1}
            title={AddFreeTrialParser.getPageHeaderInfo(1).title}
            nextStep={AddFreeTrialParser.getPageHeaderInfo(1).nextStep}
          />
        </div>
        <ChooseFreeTrialPackageForm
          onSubmit={() => navigate(AppPath.DASHBOARD)}
        />
      </div>
    </Page>
  );
};

export default SubscribeFreeTrial;
